import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const QUICK_ACTIONS = [
  { label: "Profit & Loss", desc: "View P&L statement", view: "profit-loss" },
  { label: "Balance Sheet", desc: "Assets & Liabilities", view: "balance-sheet" },
  { label: "Party Sales", desc: "Customer-wise sales", view: "party-sales" },
  { label: "Party Expense", desc: "Vendor-wise expenses", view: "party-expense" },
];

/**
 * Quick-access grid linking to the main report pages.
 */
export default function QuickActions({ onNavigate }) {
  return (
    <Card className="border border-slate-200 shadow-none">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold text-slate-700">Quick Access</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {QUICK_ACTIONS.map((action) => (
            <div
              key={action.view}
              onClick={() => onNavigate?.(action.view)}
              className="p-3 border border-slate-200 rounded-sm hover:bg-slate-50 cursor-pointer transition-colors"
              data-testid={`quick-action-${action.view}`}
            >
              <p className="text-sm font-medium text-slate-900">{action.label}</p>
              <p className="text-xs text-slate-500 mt-0.5">{action.desc}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
